import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import colors from 'vuetify/es5/util/colors'

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#0D47A1',// colors.teal.darken3, // #E53935
    secondary: colors.blue.darken1, //'#5C6BC0', // colors.teal.lighten1, // #FFCDD2
    accent: colors.blueGrey.lighten1, // #3F51B5
  }
})
